var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.$store.state.Dialog.alertDialogs, function(alert) {
      return _c(
        "div",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "290" },
              model: {
                value: alert.isAlert,
                callback: function($$v) {
                  _vm.$set(alert, "isAlert", $$v)
                },
                expression: "alert.isAlert"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v(_vm._s(alert.title))
                  ]),
                  _c("v-card-text", [_vm._v(_vm._s(alert.content))]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.$store.getters["Ajax/loading"],
                            color: "accent",
                            text: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$store.commit("RESOLVE_ALERT", alert)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.ok")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }